export var calculateRemaining = function calculateRemaining(maxLength) {
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return Math.max(0, maxLength - value.length);
};
export var calculateApproachingLimit = function calculateApproachingLimit(maxLength, remaining) {
  var limitPercentage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.1;
  return remaining <= limitPercentage * maxLength;
};
export var calculateReachedLimit = function calculateReachedLimit(remaining) {
  return remaining <= 0;
};